module.exports = __webpack_public_path__ + "img/Aria_install_poster.2b247b5e.png";